import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, SUConfirmArrival } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { MeasurementEstimateFeesComponent } from '../measurement-Estimate-fees/measurement-Estimate-fees-component';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';


@Component({
  selector: 'app-confirm-Arrival',
  templateUrl: './marine-confirm-Arrival-component.html'
})

export class ConfirmArrivalComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  decision = SUConfirmArrival;
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  displayedLang: string;
  public confirmArrivalForm: FormGroup;
  user: User = new User();
  showRequest = false;
  marineConfirmArrivalObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  smallUnitRequestDTO: SmallUnitRequest = new SmallUnitRequest();
  agentId: string;
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;
  @ViewChild('MeasurementEstimateFeesComponent',{static: false}) MeasurementEstimateFeesComponent: MeasurementEstimateFeesComponent;
  public disableForm: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private translate: TranslateService,
    private suServ: SmallUnitsServiceFE, private suAdminServ: SmallUnitsAdminService) {
    this.isShow = true;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.user = this.globalSrv.user;

  }

  ngOnInit(): void {
    this.buildForm(null);
  }
  buildForm(decision) {
    this.confirmArrivalForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == SUConfirmArrival.Arrived) {
      this.confirmArrivalForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        ActualArrivalTime: ['', [Validators.required]]

      });
    }
    if (decision == SUConfirmArrival.Cancelled) {
      this.confirmArrivalForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MarineCancelationReason: ['', [Validators.required]],
      });
    }
  }
  get f() {
    return this.confirmArrivalForm.controls;
  }
  changeDecision(value) {
    this.buildForm(value);
    this.confirmArrivalForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }
  getBaseRequest() {
    this.suServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.smallUnitRequestDTO = this.responseObj.Data;
          this.requestStatus = this.smallUnitRequestDTO.StatusId;
          this.agentId = this.smallUnitRequestDTO.RequestorId;
          // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            //to view "more information" data in case Measurement officer require it from agent and penending agent update
            //or after agent update request and pending Measurement officer approval
            if (this.smallUnitRequestDTO.MarineActionId == SUConfirmArrival.Arrived) {
              this.decisionValue = this.smallUnitRequestDTO.MarineActionId;
              this.buildForm(this.decisionValue);
              this.confirmArrivalForm.patchValue({
                Decision: this.decisionValue,
                ActualArrivalTime: new Date(this.smallUnitRequestDTO.ActualArrivalTime),
              });
            } else if (this.smallUnitRequestDTO.MarineActionId == SUConfirmArrival.Cancelled) {
              this.decisionValue = this.smallUnitRequestDTO.MarineActionId;
              this.buildForm(this.decisionValue);
              this.confirmArrivalForm.patchValue({
                Decision: this.decisionValue,
                MarineCancelationReason: this.smallUnitRequestDTO.MarineCancelationReason,
              });
            }
            this.confirmArrivalForm.disable();
            // this.disableForm=true;
            this.confirmArrivalForm.controls.Decision.disable();
          } else if (this.requestStatus == ServiceStatus.SmallUnit_PendingUnitArrival) {
            this.formMode = FormMode.Add;
            this.confirmArrivalForm.enable();
          } else {
            // to hide submit button
            this.formMode = FormMode.Readonly;
            this.confirmArrivalForm.disable();
            this.decisionValue = SUConfirmArrival.Arrived;
            //this.buildForm(this.decisionValue);
            this.changeDecision(this.decisionValue);
            this.confirmArrivalForm.patchValue({
              Decision: SUConfirmArrival.Arrived,
              ActualArrivalTime: new Date(this.smallUnitRequestDTO.ActualArrivalTime),
            });
          }

        }
      }

    )
  }
  ActualArrivalTimeChanged(event) {

    // if (event.target.value == "Invalid Date" || new Date(event.target.value) < new Date()) {
    if (event.target.value == "Invalid Date") {
      this.confirmArrivalForm.controls['ActualArrivalTime'].setErrors({ 'invalid': true });
    } else if (this.confirmArrivalForm.get("ActualArrivalTime").value){
      var ActualArrivalTime = this.confirmArrivalForm.get("ActualArrivalTime").value.toLocaleString('en-US');
      this.confirmArrivalForm.controls['ActualArrivalTime'].setValue(ActualArrivalTime);
    }
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.confirmArrivalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    if (this.confirmArrivalForm.get("ActualArrivalTime") != null && this.confirmArrivalForm.get("ActualArrivalTime").value) {
      var ActualArrivalTime = this.confirmArrivalForm.get("ActualArrivalTime").value.toLocaleString('en-US');
      this.confirmArrivalForm.controls['ActualArrivalTime'].setValue(ActualArrivalTime);
    }
    this.marineConfirmArrivalObject = this.confirmArrivalForm.value;

    this.marineConfirmArrivalObject.AdminEmail = this.user.UserName;
    this.marineConfirmArrivalObject.Id = this.baseRequestId;
    this.marineConfirmArrivalObject.MarineActionId = this.decisionValue;
    this.suAdminServ.AddConfirmArrivalDecision(this.marineConfirmArrivalObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.confirmArrivalForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
